import script from "./OrdersStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdersStatus.vue?vue&type=script&setup=true&lang=js"

import "./OrdersStatus.vue?vue&type=style&index=0&id=973b84f0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-973b84f0"]])

export default __exports__